// extracted by mini-css-extract-plugin
export var headerSection = "VideoBkgHero-module--headerSection--CJD74";
export var playerWrapper = "VideoBkgHero-module--playerWrapper--2dg4h";
export var reactPlayer = "VideoBkgHero-module--reactPlayer--1dA9j";
export var headingContentWrapper = "VideoBkgHero-module--headingContentWrapper--3u1cq";
export var headingContent = "VideoBkgHero-module--headingContent--3tn_b";
export var heading = "VideoBkgHero-module--heading--_pN1j";
export var headingButton = "VideoBkgHero-module--headingButton--1HZ0h";